import React, { useState, useRef } from 'react';
import {
	Row,
	Col,
	Container,
	Card,
	Accordion,
	Form,
	Table,
	Button,
	Alert,
	Modal,
} from 'react-bootstrap';
import XLSX from 'xlsx';
import requester from '../../lib/requester';

function SalesTarget() {
	const fileInput = useRef();
	const [data, setData] = useState([]);
	const [row, setRow] = useState([]);
	const [header, setHeader] = useState([]);
	const [showInvalidHeaderAlert, setShowInvalidHeaderAlert] = useState(false);
	const [showModalConfirmUpload, setShowModalConfirmUpload] = useState(false);
	const [showModalSuccess, setShowModalSuccess] = useState(false);
	const [disableButtonUpload, setDisableButtonUpload] = useState(false);

	const handleInputFile = (e) => {
		const file = e.target.files[0];
		const reader = new FileReader();
		reader.onload = (e) => {
			const wb = XLSX.read(e.target.result, { type: 'buffer' });
			const wsname = wb.SheetNames[0];
			const ws = wb.Sheets[wsname];
			const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
			const [header, ...row] = data;
			if (isHeaderInvalid(header)) {
				setShowInvalidHeaderAlert(true);
				setHeader([]);
				setRow([]);
				return;
			}
			setData(data);
			setShowInvalidHeaderAlert(false);
			// ! add from fahron
			header.push("ORG_ID")
			setHeader(header);
			for (var i of row) {
				i.push(JSON.parse(window.localStorage.getItem('is_user'))["org_id"]);
			}
			setRow(row);
			// ! end add from fahron
		};
		reader.readAsArrayBuffer(file);
	};

	const isHeaderInvalid = (header) => {
		if (header[0] != 'CUSTOMER_ID') return true;
		if (header[1] != 'CUSTOMER_NAME') return true;
		if (header[2] != 'BRANCH_ID') return true;
		if (header[3] != 'CLASS') return true;
		if (header[4] != 'PROGRAM_NAME') return true;
		if (header[5] != 'QUARTER') return true;
		if (header[6] != 'BRAND_CHD') return true;
		if (header[7] != 'SUB_ACCOUNT') return true;
		if (header[8] != 'TARGET_VALUE') return true;
		return false;
	};

	const alertInvalidHeader = () => (
		<Row>
			<Col>
				<Alert
					variant='danger'
					onClose={() => setShowInvalidHeaderAlert(false)}
					dismissible>
					<Alert.Heading>Oh snap! You got an error!</Alert.Heading>
					<p>Invalid column, please upload another file!</p>
					<p>Column must be like this:</p>
					<Table size='sm' striped bordered hover responsive>
						<thead>
							<tr style={{ fontSize: 12 }}>
								<th>CUSTOMER_ID</th>
								<th>CUSTOMER_NAME</th>
								<th>BRANCH_ID</th>
								<th>CLASS</th>
								<th>PROGRAM_NAME</th>
								<th>QUARTER</th>
								<th>BRAND_CHD</th>
								<th>SUB_ACCOUNT</th>
								<th>TARGET_VALUE</th>
							</tr>
						</thead>
					</Table>
				</Alert>
			</Col>
		</Row>
	);

	const upload = () => {
		setDisableButtonUpload(true);
		const url = '/api/traces_chd/v1/upload/sales-target';
		requester.postCHD(url, data, {
			success: (res) => {
				setShowModalConfirmUpload(false);
				setShowModalSuccess(true);
				setRow([]);
				setHeader([]);
				setDisableButtonUpload(false);
			},
			error: (err) => {
				setDisableButtonUpload(false);
				console.log(err);
			},
		});
	};

	const renderModalConfirmUpload = () => (
		<Modal
			centered
			show={showModalConfirmUpload}
			onHide={() => setShowModalConfirmUpload(false)}>
			<Modal.Header closeButton>
				<Modal.Title>Upload Sales Target</Modal.Title>
			</Modal.Header>
			<Modal.Body>Are you sure?</Modal.Body>
			<Modal.Footer>
				<Button
					variant='secondary'
					onClick={() => setShowModalConfirmUpload(false)}>
					Cancel
				</Button>
				<Button
					disabled={disableButtonUpload}
					variant='primary'
					onClick={() => upload()}>
					Yes, Upload Now!
				</Button>
			</Modal.Footer>
		</Modal>
	);

	const renderModalUploadSuccess = () => (
		<Modal
			centered
			show={showModalSuccess}
			onHide={() => setShowModalSuccess(false)}>
			<Modal.Header closeButton>
				<Modal.Title>Upload Sales Target</Modal.Title>
			</Modal.Header>
			<Modal.Body>Successfully uploaded data!</Modal.Body>
			<Modal.Footer>
				<Button variant='primary' onClick={() => setShowModalSuccess(false)}>
					OK
				</Button>
			</Modal.Footer>
		</Modal>
	);

	const downloadTemplate = () => {
		const workbook = XLSX.utils.book_new();
		const worksheet = XLSX.utils.aoa_to_sheet([
			[
				'CUSTOMER_ID',
				'CUSTOMER_NAME',
				'BRANCH_ID',
				'CLASS',
				'PROGRAM_NAME',
				'QUARTER',
				'BRAND_CHD',
				'SUB_ACCOUNT',
				'TARGET_VALUE',
			],
		]);
		XLSX.utils.book_append_sheet(workbook, worksheet, 'sales_target');
		XLSX.writeFile(workbook, 'sales_target_template.xlsx', {
			bookType: 'xlsx',
		});
	};

	return (
		<Container>
			{showInvalidHeaderAlert && alertInvalidHeader()}
			<Row>
				<Col>
					<Card>
						<Card.Header style={{ backgroundColor: 'rgba(0,0,0,0.03)' }}>
							UPLOAD SALES TARGET
						</Card.Header>
						<Card.Body>
							<Row>
								<Col>
									<Form>
										<Form.Group>
											<Form.File
												ref={fileInput}
												onChange={handleInputFile}
												accept='.xlsx,.xls,.csv'
											/>
										</Form.Group>
									</Form>
								</Col>
								<Col className='text-right'>
									<Button onClick={downloadTemplate}>Download Template</Button>
								</Col>
							</Row>
							<Row>
								<Col>
									{row.length > 0 && (
										<>
											<Table size='sm' striped bordered hover responsive>
												<thead>
													<tr>
														<th>#</th>
														{header.map((val, i) => (
															<th key={i}>{val}</th>
														))}
													</tr>
												</thead>
												<tbody>
													{row.map((col, i) => {
														return (
															<tr key={i}>
																<td>{i + 1}</td>
																{col.map((val, x) => (
																	<td key={x}>{val}</td>
																))}
															</tr>
														);
													})}
												</tbody>
											</Table>
											<Button
												onClick={() => setShowModalConfirmUpload(true)}
												className='mt-2'
												block
												variant='dark'>
												Upload
											</Button>
										</>
									)}
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
			{renderModalConfirmUpload()}
			{renderModalUploadSuccess()}
		</Container>
	);
}

export default SalesTarget;
